export const mbForms = {
  registrationConfirmation: {
    successfulMessage: 'Your account has been successfully created!',
    goToMyAccount: 'Go to my account',
    proceedToCheckout: 'Proceed to checkout'
  },
  registrationProgress: {
    contact: 'Contact details',
    shippingAndBilling: 'Shipping & billing address',
    review: 'Submit registration'
  },
  countrySelector: {
    headline: 'Please select the country for your account',
    subline1: 'Your selected country should reflect the location of your shipping address and billing address.',
    subline2: 'If you are unable to find your matching country please contact your local Customer Service.',
    dropdownselect: 'Country of your account'
  },
  quoteInfo: {
    error: 'Something went wrong. Please try again.',
    headline: 'Thank you for your interest in our products!',
    whatsNext: 'What´s next',
    step1: 'Please provide your contact information in the next steps.',
    step2: 'Please note that you are not submitting an order but you are requesting a quote. We will identify the dedicated expert who will take care of your request.',
    step3: 'You will be contacted as soon as possible.',
    selectCountry: 'Please choose the country that reflects your shipping information.',
    migrationError: 'Something went wrong when migrating the cart. Please try again.'
  },
  contact: {
    pleaseEnterYourInfo: 'Please enter your contact information',
    requestHeadline1: 'Please enter your contact information for a personalized quote',
    requestHeadline2: 'We will get in touch with you as soon as possible.',
    purchaseHeadline1: 'Please enter your contact information',
    mandatoryFields: '*mandatory fields',
    salutation: 'Salutation',
    title: 'Title',
    role: 'Role',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-mail',
    customerNumber: 'Customer number',
    phoneNumber: 'Phone no.',
    error: 'Something went wrong. Please try again.',
    us: {
      salutation: 'Salutation',
      title: 'Academic degree',
      role: 'Job title',
      firstName: 'First full name',
      lastName: 'Last name',
      email: 'E-mail',
      customerNumber: 'Customer number',
      phoneNumber: 'Phone no.',
    }, un: {
      salutation: 'Salutation',
      title: 'Academic title',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Business email',
      phoneNumber: 'Phone no.',
      role: 'Role',
    }
  },
  address: {
    notOnShippingLabel: 'Not on shipping label',
    purchaseBillingAddressFormHeadline: 'Enter your billing information',
    purchasePaymentHeadline: 'Your payment method',
    requestBillingAddressHeadline1: 'Add your billing information',
    requestBillingAddressHeadline2: 'You are requesting a personalized quote. You will not be charged.',
    shippingAddressHeadline: 'Select your shipping address',
    prefillText: 'Prefill with my shipping address',
    pleaseEnterYourShippingAddress: 'Enter your shipping address',
    purchaseBillingAddressHeadline: 'Your billing information',
    companyUniversity: 'Company/University',
    institute: 'Institute',
    departmentDivision: 'Department/Division',
    buildingFloorRoom: 'Building/Floor/Room',
    labGroupPI: 'Lab/Group/PI',
    street: 'Street address',
    houseNumber: 'House number',
    zipCode: 'Postal code/ZIP code',
    city: 'City',
    state: 'State',
    vatId: 'VAT ID',
    salesTaxExemption: 'Sales Tax Exemption: ',
    salesTaxExemptionText: 'Please check this box only if you are currently exempt from sales tax and can provide or ' +
      'have provided documentation of such.',
    sameAddressText: 'My shipping address is also my billing address',
    addNewAddress: 'Add new address',
    internalRefNumber: 'Internal reference number',
    error: 'Something went wrong. Please try again.',
    userError: 'User error. Please try again.',
    mandatoryMissingError: 'Please fill in all mandatory fields.',
    status: {
      inVerification: 'Address will be verified during order process',
      verified: 'Verified address',
      rejected: 'Address denied'
    },
    poInternalRefNum: 'PO / Internal Reference Number',
    optional: 'optional',
    mandatory: 'mandatory',
    us: {
      companyUniversity: 'Company/University',
      institute: 'Institute',
      departmentDivision: 'Department/Division',
      buildingFloorRoom: 'Building/Floor/Room',
      additionalShippingInformation: 'Additional shipping information, e.g. building, floor, room',
      labGroupPI: 'Lab/Group/PI',
      street: 'Street address',
      houseNumber: 'House number',
      zipCode: 'Postal code/ZIP code',
      city: 'City',
      state: 'State',
      vatId: 'VAT ID',
      salesTaxExemption: 'Sales Tax Exemption',
      salesTaxExemptionText: 'Please check this box only if you are currently exempt from sales tax and can provide or ' +
        'have provided documentation of such.',
      internalRefNumber: 'PO Number',
      poBoxMessage: 'Please note we are unable to deliver to a P.O. box',
    },
    un: {
      companyUniversity: 'Company/University',
      institute: 'Institute',
      departmentDivision: 'Department/Division',
      buildingFloorRoom: 'Building/Floor/Room',
      labGroupPI: 'Lab/Group/PI',
      street: 'Street address',
      houseNumber: 'House number',
      city: 'City',
      zipCode: 'Postal code/ZIP code'
    }
  },
  review: {
    headline: 'Please review your information',
    checkoutNotes: 'Additional notes e.g. Promo codes (optional)',
    checkoutNotesMobile: 'Additional notes e.g. Promo codes (opt.)',
    checkoutUSNotes: 'Optional (promo codes, IND/IDE number, etc.)',
    standardDelivery: 'Standard delivery',
    creditCard: 'Credit Card',
    invoice: 'Invoice',
    yourPoNumber: 'Your PO Number:',
    internalReferenceNumber: 'Internal reference number:',
    poInternalRefNum: 'PO / Internal Reference Number:',
    contactDetails: 'Contact details',
    shipmentMethod: 'Shipment method',
    shippingAddress: 'Shipping address',
    paymentMethod: 'Payment method',
    orderStatus: 'Order status',
    additionalInfo: 'Additional information',
    additionalInfoDescription: 'Please type anything that helps you identify your order.',
    billingInformation: 'Billing information',
    notes: 'Additional notes',
    error: 'Something went wrong. Please try again.',
    us: {
      internalReferenceNumber: 'PO Number:',
    }
  }
}
